module.exports = __webpack_public_path__ + "img/ac8cb.360e15c2.svg";